import { SSF } from 'xlsx';

function pad(value: number): string {
  return String(value).padStart(2, '0');
}

export function toIsoDate(value: unknown): string | null {
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return `${value.getFullYear()}-${pad(value.getMonth() + 1)}-${pad(value.getDate())}`;
  }

  if (typeof value === 'number' && Number.isFinite(value)) {
    const parsed = SSF.parse_date_code(value);
    if (parsed) {
      return `${parsed.y}-${pad(parsed.m)}-${pad(parsed.d)}`;
    }
  }

  if (typeof value === 'string') {
    const text = value.trim();
    const isoMatch = text.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (isoMatch) {
      return `${isoMatch[1]}-${isoMatch[2]}-${isoMatch[3]}`;
    }

    const italianMatch = text.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
    if (italianMatch) {
      return `${italianMatch[3]}-${pad(Number(italianMatch[2]))}-${pad(Number(italianMatch[1]))}`;
    }

    const parsed = new Date(text);
    if (!Number.isNaN(parsed.getTime())) {
      return `${parsed.getFullYear()}-${pad(parsed.getMonth() + 1)}-${pad(parsed.getDate())}`;
    }
  }

  return null;
}

export function isoDateToUtcTimestamp(value: string): number {
  const [year, month, day] = value.split('-').map(Number);
  return Date.UTC(year, month - 1, day, 12, 0, 0);
}

export function compareIsoDates(a: string | null, b: string | null): number {
  if (a === b) return 0;
  if (a === null) return -1;
  if (b === null) return 1;
  return a.localeCompare(b);
}

export function formatItalianDate(value: string | null | undefined): string {
  if (!value) return 'n.d.';
  return new Intl.DateTimeFormat('it-IT', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    timeZone: 'UTC',
  }).format(new Date(isoDateToUtcTimestamp(value)));
}

export function formatQuarter(value: string | number): string {
  const timestamp = typeof value === 'number' ? value : isoDateToUtcTimestamp(value);
  const date = new Date(timestamp);
  const quarter = Math.floor(date.getUTCMonth() / 3) + 1;
  return `Q${quarter} ${date.getUTCFullYear()}`;
}
